$(document).ready(function() {

    $(document).on("click", ".js-toggle-download", function(e){

        if(!$(e.target).hasClass("links-wrap") &&
            !$(e.target).parents().hasClass("links-wrap")){

            $(this).toggleClass("opened");
        }

        if(!$(this).hasClass("opened")){
            setTimeout(()=>{
                $(this).find(".links-wrap").removeClass("opened");
            },400);
        }
    });
});

